import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  fetchPostsSuccess:false,
  fetchSinglePostSuccess:false,
  posts: [],
  post: {},
  postcats: [],
  postcat: {},
  catPosts: [],
  comments: [],
  coursePageError: false
};


const allPosts = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case CONSTANTS.SHOWERROR_PAGEBLOG:
      return Object.assign({}, state, {
        coursePageError: true
      });
    case CONSTANTS.GET_POSTS:
      return Object.assign({}, state, {
        loading: false,
        posts: action.posts,
        fetchPostsSuccess: true
      });
    case CONSTANTS.GET_POST:
      return Object.assign({}, state, {
        loading: false,
        post: action.post,
        fetchSinglePostSuccess:true
      });
    case CONSTANTS.GET_CAT_POSTS:
      return Object.assign({}, state, {
        loading: false,
        catPosts: action.posts,
      });
    case CONSTANTS.GET_POSTCATS:
      return Object.assign({}, state, {
        loading: false,
        postcats: action.postcats
      });
    case CONSTANTS.GET_POSTCAT:
      return Object.assign({}, state, {
        loading: false,
        postcat: action.postcat
      });
    case CONSTANTS.GET_COMMENTS:
      return Object.assign({}, state, {
        loading: false,
        comments: action.comments
      });
    default:
      return state;
  }
};

export default allPosts;
